import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {ImportUtil} from '../../utils/importUtil.js';
import {attachWorkspaceFilterState} from '../../utils/workspaceStateUtil.js';
import {RoutingService} from '../../service/routing/routingService.js';
import {BaseComponent} from '../basecomponent.js';
import {DataTools} from './dataTools.js';


/* global customElements */
class TimeToolZoneGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var timeToolZoneGrid = this;
		setTimeout(function(){
			timeToolZoneGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var timeToolZoneGrid = this;
	
		var toolbarForm = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',			
			children: [	
				{
					tag: 'vaadin-date-time-picker',
					itemId: 'inputDate',
					label: 'Check Date (In Company Timezone)',
					'class': 'spacer-toolbar-item',	
					'helper-text': '(mm/dd/yyyy hh:mm:ss)',
					name: 'inputDate',					
					step: 1,
					value: TimeUtil.formatDateForDateLoad(new Date()) + 'T00:00:00',
					required: true
				},				
				{					
					tag: 'vaadin-text-field',
					'class': 'spacer-toolbar-item',	
					itemId: 'shiftTimezoneOrHours',
					name: 'shiftTimezoneOrHours',
					label: 'Timezone or Hours',
					'helper-text': 'timezone code(CDT) or +/-hours',
					required: true
				}
			]
		});
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'add',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')
					], 
					listeners: {
						click: function() {
							actionAdd();
						}
					}
				},
				{
					tag: 'div',
					style: 'float: right;',
					children:[
						{
							tag: 'dl-action-button',
							itemid: 'delete',
							'class': 'spacer-toolbar-item',	
							theme: 'error primary',
							disabled: true,
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' Delete')						
							],
							listeners: {
								click: function() {
									actionDelete(grid.selectedItems[0]);
								}
							}							
						},
						{
							tag: 'dl-action-button',
							itemid: 'deleteClear',
							'class': 'spacer-toolbar-item',	
							theme: 'error primary',						
							children:[
								ElementUtil.makeIcon('vaadin:close', ' Clear All')						
							],
							listeners: {
								click: function() {
									actionClearAll();
								}
							}							
						}
					]
				}											
			]
		});		
		
		var toolbarContainer = ElementUtil.create({
			tag: 'div',
			slot: 'toolbar',
			children: [
				toolbarForm,
				ElementUtil.create({
					tag: 'hr'
				}),
				toolbar
			]
		});			
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [					
				{						
					path: 'serverTimeInput',
					header: 'Server Date (Sent By User)',
					width: '7em'
				},
				{						
					path: 'inputShift',
					header: 'Input Shift',
					width: '7em'
				},
				{						
					path: 'serverTimeOutput',
					header: 'Server Time (Shifted)',
					width: '7em'
				},
				{						
					path: 'translatedDate',
					header: 'Company Display Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.translatedDate);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {
						ElementUtil.query(toolbar, 'delete').disabled = false;						
					} else {
						ElementUtil.query(toolbar, 'delete').disabled = true;
					}
				}
			}
		});	
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarContainer,
				grid
			]
		});		
		timeToolZoneGrid.append(flexLayout);		
		
		var results = [];		
		var actionRefresh = function() {
			grid.activeItem = null;
			grid.items = results.slice(0);	
		};

		attachWorkspaceFilterState(timeToolZoneGrid, toolbarForm, ['inputDate','shiftTimezoneOrHours'], actionRefresh);
		
		var actionAdd = function() {
			var loadMask = grid.showLoading();
			var request = {
				inputDate: ElementUtil.query(toolbarForm, 'inputDate').value,
				shiftTimezoneOrHours: ElementUtil.query(toolbarForm, 'shiftTimezoneOrHours').value
			};
			request.inputDate = TimeUtil.parseDate(request.inputDate).toISOString();
						
			DataManagementService.getTimeToolService().timezone(request).then(function(result){
				loadMask.remove();
				if (result.inputShift) {					
					results.push(result);
					actionRefresh();
				}
			}).catch(function(result){
				loadMask.remove();
			});
		};
		
		var actionDelete = function(record) {
			var newResults = [];
			results.forEach(function(item){
				var keep = true;
				if (item.translatedDate === record.translatedDate &&
					item.inputShift === record.inputShift &&
					item.serverTimeOutput === record.serverTimeOutput &&
					item.serverTimeInput === record.serverTimeInput) {
					keep = false;					
				}
				if (keep) {
					newResults.push(item);
				}
			});
			results = newResults;
			actionRefresh();
		};
		
		var actionClearAll = function() {
			
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Clear',
				message: '<b>Are you sure you want to clear all results?<b> ',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							results = [];
							actionRefresh();					
						}
					},
					{
						text: 'No'
					}
				]
			});			
			
			
		};
		
	}
	
}
customElements.define('dl-timetool-zone-grid', TimeToolZoneGrid);

